import type { NavItem } from "../../types";
import { currentSitePath, siteUrl } from "../../wordpress";
import "./MainNav.css";

type MainNavProps = {
	items: NavItem[];
};

/**
 * Navegação da barra. O primeiro item é a secção em que a página abre, por
 * isso leva o traço vermelho de item activo.
 */
export function MainNav({ items }: MainNavProps) {
	const currentPath = currentSitePath();

	return (
		<nav className="main-nav" aria-label="Navegació principal">
			<ol>
				{items.map((item) => {
					if (item.children?.length) {
						const childCurrent = item.children.some((child) =>
							currentPath.startsWith(child.href),
						);

						return (
							<li key={item.label} className="main-nav__item has-children">
								<span
									className={childCurrent ? "is-current" : undefined}
									aria-haspopup="true"
								>
									{item.label}
								</span>
								<ul className="main-nav__submenu">
									{item.children.map((child) => {
										const childIsCurrent = currentPath.startsWith(child.href);

										return (
											<li key={child.href}>
												<a
													href={siteUrl(child.href)}
													className={childIsCurrent ? "is-current" : undefined}
													aria-current={childIsCurrent ? "page" : undefined}
													target={child.external ? "_blank" : undefined}
													rel={child.external ? "noreferrer" : undefined}
												>
													{child.label}
												</a>
											</li>
										);
									})}
								</ul>
							</li>
						);
					}

					const current = item.href === "/"
						? currentPath === "/"
						: currentPath.startsWith(item.href);

					return (
					<li key={item.href}>
						<a
							href={siteUrl(item.href)}
							className={current ? "is-current" : undefined}
							aria-current={current ? "page" : undefined}
							target={item.external ? "_blank" : undefined}
							rel={item.external ? "noreferrer" : undefined}
						>
							{item.label}
						</a>
					</li>
					);
				})}
			</ol>
		</nav>
	);
}
